export default "__VITE_ASSET__D49gLuTl__"